import { Texts, Title, Media, Button } from "../Object";
import { Space } from "../Layout";
import { NewsList } from '../Post';

const News = () => {
  return (
    <>
      <div className="l-row l-row--normal">
        <Space size={['120px', '80px']}></Space>
        <div className="p-box__news">
          <div className="p-title__wrap--link">
            <div className="p-box__news--left">
              <Title slug="news" type=""></Title>
            </div>
          </div>
          <Space size={['64px 0 0', '40px 0 0']}>
            <NewsList />
          </Space>
        </div>
        <Space size={['120px', '80px']}></Space>
      </div>
    </>
  );
};

export default News;